import React, { useEffect } from "react";
import { isAfter } from "date-fns";
import AppProvider from "./hooks/";
import Routes from "./routes/";
import GlobalStyle from "./styles/";
import { ThemeProvider } from "styled-components";
import { lightTheme } from "./styles/theme";

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]");

if (
  process.env.NODE_ENV === "production" &&
  "serviceWorker" in navigator &&
  !isLocalHost
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => console.log("Service Worker registrado:", reg))
      .catch((err) => console.log("Erro no Service Worker:", err));
  });
}

function App() {
  const access_token = localStorage.getItem("@7Cantos:token");
  const dateToExpires = localStorage.getItem("@7Cantos:dateToExpires");

  useEffect(() => {
    async function loadApi() {
      if (!!dateToExpires) {
        const actualDate = new Date(Date.now());
        const dateToExpiresFormated = new Date(dateToExpires);

        if (isAfter(actualDate, dateToExpiresFormated)) {
          localStorage.removeItem("@7Cantos:token");
          localStorage.removeItem("@7Cantos:user");
          localStorage.removeItem("@7Cantos:dateToExpires");

          window.location.reload();
        }
      }
    }

    if (!!access_token) {
      loadApi();
    }
  }, [access_token, dateToExpires]);

  return (
    <ThemeProvider theme={lightTheme}> 
      <AppProvider>
        <Routes />
      </AppProvider>
      <GlobalStyle />
    </ThemeProvider>
  );
}

export default App;
